import React from "react";
import s from "./Cells.less";

interface DealerNameCellProps {
  dealerName?: {
    [lang: string]: {
      name?: string;
      other?: string;
    };
  } | null;
  lang?: string | null;
}

export const DealerNameCell: React.FC<DealerNameCellProps> = ({
  dealerName,
  lang,
}) => {
  if (!dealerName) return <span>-</span>;

  const currentLang = lang || localStorage.getItem("language") || "ru";
  const dealerData = dealerName[currentLang];

  if (!dealerData) return <span>-</span>;

  return (
    <div className={s.dealerData}>
      <div>{dealerData.name || "-"}</div>
      {dealerData.other && <div>{dealerData.other}</div>}
    </div>
  );
};
